import { useMemo } from 'react';

// Common passwords list
const COMMON_PASSWORDS = new Set([
  'password', 'password1', 'password123', '123456', '12345678', '123456789',
  'qwerty', 'qwerty123', 'abc123', 'letmein', 'welcome', 'admin', 'admin123',
  'iloveyou', 'monkey', 'dragon', 'master', 'login', 'passw0rd', 'p@ssword',
  '1234567890', 'sunshine', 'princess', 'football', 'baseball', 'trustno1'
]);

export interface PasswordValidation {
  hasMinLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
  isNotCommon: boolean;
  passwordsMatch: boolean;
  isValid: boolean;
}

export function usePasswordValidation(
  password: string,
  confirmPassword?: string
): PasswordValidation {
  return useMemo(() => {
    const hasMinLength = password.length >= 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(password);
    const isNotCommon = password.length === 0 || !COMMON_PASSWORDS.has(password.toLowerCase());
    const passwordsMatch = confirmPassword !== undefined
      ? password === confirmPassword && confirmPassword.length > 0
      : true;

    const isValid = hasMinLength && hasUppercase && hasLowercase &&
                    hasNumber && hasSpecialChar && isNotCommon && passwordsMatch;

    return {
      hasMinLength,
      hasUppercase,
      hasLowercase,
      hasNumber,
      hasSpecialChar,
      isNotCommon,
      passwordsMatch,
      isValid
    };
  }, [password, confirmPassword]);
}
